// import React from 'react'
// import Constants from 'EurestoFonction/Constants'
// import User from 'EurestoClass/User'
// import Data from 'EurestoClass/Data'
// import EurestoDiv from 'EurestoComponents/EurestoDiv'
// import Masonery from 'Components/Masonery'
// import DataTiers from './Data'
// import Grid from '@material-ui/core/Grid'

// export default class extends React.Component {

//   shouldComponentUpdate(nextProps, nextState, nextContext) {
//     return this.props.contact.information_tiers !== nextProps.contact.information_tiers
//       || this.props.disabled !== nextProps.disabled
//   }

//   constructor(props) {
//     super(props)

//     const search = {
//       type_entite_information: {
//         or: [
//           {
//             contains: [props.contact.entite]
//           }
//         ]
//       }
//     }
//     if (props.contact.qualite_id !== undefined) {
//       search.qualites = {
//         or: [
//           {
//             contains: props.contact.qualite_id
//           }, {
//             isEmpty: true
//           }
//         ]
//       }
//     } else {
//       search.qualites = {
//         isEmpty: true
//       }
//     }
//     if (props.typeContact === Constants.access.ETABLISSEMENT) {
//       search.type_entite_information.or.push({ contains: [4] })
//     } else if (props.typeContact === Constants.access.GROUPE) {
//       search.type_entite_information.or.push({ contains: [5] })
//     }

//     if (User.TypeAccess.get(Constants.access.EURESTO)) {
//       search.actif = {
//         not: true,
//         value: 3
//       }
//     }

//     const onglets = Data.list(Constants.module.CRM, Constants.donnee.onglet, search)
//     const infosTiers = Data.list(Constants.module.CRM, Constants.donnee.info_tiers, search)


//     infosTiers.sort((a, b) => {
//       if (a.onglet_id === b.onglet_id) {
//         if (a.ordre === b.ordre) {
//           return ('' + a.libelle).localeCompare(b.libelle)
//         }
//         return a.ordre - b.ordre
//       }
//       return a.onglet_id - b.onglet_id
//     })

//     this.state = {
//       onglets: onglets,
//       infosTiers: infosTiers
//     }
//   }

//   render() {
//     console.log("¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹", this.state.onglets.filter((onglet, i) => (this.state.infosTiers.filter(info => info.onglet_id === onglet.id).length > 0))[0])
//     console.log("¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹¹", this.state.onglets.filter((onglet, i) => (this.state.infosTiers.filter(info => info.onglet_id === onglet.id).length > 0))[1])

//     return (<Grid container>

//       <Masonery
//         style={{
//           padding: 10
//         }} lg={3} md={2} sm={1}
//         datas={this.state.onglets.filter((onglet, i) => (this.state.infosTiers.filter(info => info.onglet_id === onglet.id).length > 0))}
//         component={this.InfoTiersOnglet} />
//       {
//         this.state.infosTiers.filter(info => info.onglet_id === undefined || info.onglet_id === null).length > 0 &&
//         <EurestoDiv
//           id={'onglet_contact_onglet_critere_-1_divers'}
//           style={{ padding: 10 }}
//           title='Divers' expandable expanded>
//           <Masonery style={{
//             padding: 10
//           }} lg={3} md={2} sm={1}
//             datas={this.state.infosTiers.filter((info, j) => (info.onglet_id === undefined || info.onglet_id === null))}
//             component={this.InfoTiersComponent} />
//         </EurestoDiv>
//       }
//     </Grid>)
//   }
//   lightColor = ['#dbffff', '#ffd0b0', '#ffffc2', '#c0cfff', '#ffbcaf'];

//   InfoTiersOnglet = (onglet, i) => <EurestoDiv
//     id={'onglet_contact_onglet_critere' + onglet.id + '_' + onglet.libelle}
//     backgroundColor={this.lightColor[i % 5]}
//     style={{ padding: 10 }}
//     key={'div-' + i + onglet.id + '-' + onglet.libelle.replace(' ', '_')}
//     title={onglet.libelle} expandable expanded>
//     {
//       this.state.infosTiers.filter((info, j) => onglet.information_tiers.indexOf(info.id) !== -1)
//         .map(this.InfoTiersComponent)
//     }
//   </EurestoDiv>

//   InfoTiersComponent = (info, i) => <DataTiers
//     key={info.id + i + info.information_tiers}
//     disabled={this.props.disabled}
//     inline
//     info={info}
//     information_tiers={this.props.contact.information_tiers}
//     contact={this.props.contact}
//     onChangeInfo={this.props.onChange} />

// }
import Grid from '@material-ui/core/Grid'
import Masonery from 'Components/Masonery'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Constants from 'EurestoFonction/Constants'
import React from 'react'
import DataTiers from './Data'

export default class extends React.Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.props.contact.information_tiers !== nextProps.contact.information_tiers
      || this.props.disabled !== nextProps.disabled
  }

  constructor(props) {
    super(props)

    const search = {
      type_entite_information: {
        or: [
          {
            contains: [props.contact.entite]
          }
        ]
      }
    }
    if (props.contact.qualite_id !== undefined) {
      search.qualites = {
        or: [
          {
            contains: props.contact.qualite_id
          }, {
            isEmpty: true
          }
        ]
      }
    } else {
      search.qualites = {
        isEmpty: true
      }
    }
    if (props.typeContact === Constants.access.ETABLISSEMENT) {
      search.type_entite_information.or.push({ contains: [4] })
    } else if (props.typeContact === Constants.access.GROUPE) {
      search.type_entite_information.or.push({ contains: [5] })
    }

    if (User.TypeAccess.get(Constants.access.EURESTO)) {
      search.actif = {
        not: true,
        value: 3
      }
    }

    const onglets = Data.list(Constants.module.CRM, Constants.donnee.onglet, search).filter(o => o.actif > 0)
    const infosTiers = Data.list(Constants.module.CRM, Constants.donnee.info_tiers, search).filter(o => o.actif > 0)


    infosTiers.sort((a, b) => {
      if (a.onglet_id === b.onglet_id) {
        if (a.ordre === b.ordre) {
          return ('' + a.libelle).localeCompare(b.libelle)
        }
        return a.ordre - b.ordre
      }
      return a.onglet_id - b.onglet_id
    })

    this.state = {
      onglets: onglets,
      infosTiers: infosTiers
    }
  }

  render() {
    const lightColor = ['#dbffff', '#ffd0b0', '#ffffc2', '#c0cfff', '#ffbcaf'];
    return (<Grid container>
      {
        this.state.onglets.map((onglet, i) => (this.state.infosTiers.filter(info => info.onglet_id === onglet.id).length > 0 &&
          <EurestoDiv
            id={'onglet_contact_onglet_critere' + onglet.id + '_' + onglet.libelle}
            backgroundColor={lightColor[i % 5]}
            key={'div-' + onglet.id + '-' + onglet.libelle.replace(' ', '_')}
            title={onglet.libelle} expandable expanded>
            <Masonery
              mykey={onglet.id + '-' + onglet.libelle.replace(' ', '_')} style={{
                padding: 10
              }} lg={3} md={2} sm={1} datas={this.state.infosTiers.filter((info, j) => info.onglet_id === onglet.id)}
              component={this.InfoTiersComponent} />
          </EurestoDiv>))
      }

      {
        this.state.infosTiers.filter(info => info.onglet_id === undefined || info.onglet_id === null).length > 0 &&
        <EurestoDiv
          id={'onglet_contact_onglet_critere_-1_divers'}
          title='Divers' expandable expanded>
          <Masonery style={{
            padding: 10
          }} lg={3} md={2} sm={1}
            datas={this.state.infosTiers.filter((info, j) => (info.onglet_id === undefined || info.onglet_id === null))}
            component={this.InfoTiersComponent} />
        </EurestoDiv>
      }
    </Grid>)
  }

  InfoTiersComponent = (info, i) => <DataTiers
    key={info.id + this.props.contact.information_tiers}
    disabled={this.props.disabled}
    info={info}
    information_tiers={this.props.contact.information_tiers}
    contact={this.props.contact}
    onChangeInfo={this.props.onChange} />

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/InformationTiers/index.js